import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './sectionGroup.module.scss';
// eslint-disable-next-line import/no-cycle
import WebsiteComponent from '../websiteComponent/websiteComponent';

function SectionGroup({
  background = null,
  removePaddingTop = false,
  removePaddingBottom = false,
  childComponents = [],
  isExistingUser,
  isUserLoggedIn,
}) {
  const wrapperClassName = classNames(styles.sectionGroup, {
    [styles.backgroundGradient]: background === 'gradient',
    [styles.backgroundEggshell]: background === 'eggshell',
    [styles.noPaddingTop]: removePaddingTop,
    [styles.noPaddingBottom]: removePaddingBottom,
  });

  return (
    <div className={wrapperClassName}>
      {childComponents
        .filter((c) => c.type !== 'sectionGroup')
        .map((component, index) => {
          const key = `${component.type}-${index}`;
          return (
            <WebsiteComponent
              key={key}
              {...component}
              isExistingUser={isExistingUser}
              isUserLoggedIn={isUserLoggedIn}
            />
          );
        })}
    </div>
  );
}

SectionGroup.propTypes = {
  background: PropTypes.oneOf(['gradient', 'eggshell']),
  removePaddingTop: PropTypes.bool,
  removePaddingBottom: PropTypes.bool,
  childComponents: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      data: PropTypes.object,
      theme: PropTypes.string,
      id: PropTypes.string,
    })
  ),
  isExistingUser: PropTypes.bool,
  isUserLoggedIn: PropTypes.bool,
};

export default SectionGroup;
